/**
 * A function to create a log object for the 'donationsBmPageLoad' event (evid: 101)
 *
 * Event description: every load of bm page
 *
 * @param {donationsBmPageLoadParams} params - The parameters for this event
 * @property {string} pageName - donations main, campaign form, donations (orders), donors (contacts)
 * @return {LogObject<donationsBmPageLoadParams>} LogObject<donationsBmPageLoadParams>
 */
export function donationsBmPageLoad(params) {
    return { evid: 101, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickViewDonations' event (evid: 102)
 *
 * Event description: Click View Donations
 *
 * @param {clickViewDonationsParams} params - The parameters for this event
 * @property {string} origin - donations main, campaign panel, campaign form
 * @property {GUID} campaignId - campaign ID
 * @return {LogObject<clickViewDonationsParams>} LogObject<clickViewDonationsParams>
 */
export function clickViewDonations(params) {
    return { evid: 102, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickCreateNewCampaign' event (evid: 105)
 *
 * Event description: Click Create new campaign
 *
 * @param {clickCreateNewCampaignParams} params - The parameters for this event
 * @return {LogObject<clickCreateNewCampaignParams>} LogObject<clickCreateNewCampaignParams>
 */
export function clickCreateNewCampaign(params) {
    return { evid: 105, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickEditCampaign' event (evid: 106)
 *
 * Event description: Click Edit Campaign
 *
 * @param {clickEditCampaignParams} params - The parameters for this event
 * @property {GUID} campaignId - campaignId
 * @return {LogObject<clickEditCampaignParams>} LogObject<clickEditCampaignParams>
 */
export function clickEditCampaign(params) {
    return { evid: 106, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickSaveCampaign' event (evid: 107)
 *
 * Event description: Click Save Campaign
 *
 * @param {clickSaveCampaignParams} params - The parameters for this event
 * @property {boolean} suggestedAmountToggle - On / Off
 * @property {number} maxAmountByDonorLimit - max amount by donor limit
 * @property {boolean} notesFromDonorToggle - On / Off
 * @property {number} minAmountByDonorLimit - min amount by donor limit
 * @property {string} actionType - create new campaign / save edit
 * @property {string} frequency - list of frequencies
 * @property {GUID} campaignId - campaignId
 * @property {string} suggestedAmounts - list of suggested amounts
 * @property {boolean} amountByDonorToggle - On / Off
 * @property {number} TargetAmount - The amount the user set as target/ Null in cases he didn’t
 * @property {DateTime} Deadline - The date set as end of campaign/ Null in cases he didn’t
 * @property {boolean} IsacceptDonationsAfterDeadline - If user choose to accept than True
 * Else false
 * @property {boolean} IsAcceptdonationsAfterGoal - If user choose to accept than True
 * Else false
 * @property {string} DonationImpact - The string represents the impact of the amount chosen / null when not relevant
 * @return {LogObject<clickSaveCampaignParams>} LogObject<clickSaveCampaignParams>
 */
export function clickSaveCampaign(params) {
    return { evid: 107, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickManageCampaigns' event (evid: 108)
 *
 * Event description: Click Manage Campaigns
 *
 * @param {clickManageCampaignsParams} params - The parameters for this event
 * @property {string} origin - gfpp, Choose Campaign Panel
 * @return {LogObject<clickManageCampaignsParams>} LogObject<clickManageCampaignsParams>
 */
export function clickManageCampaigns(params) {
    return { evid: 108, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'chooseCampaign' event (evid: 109)
 *
 * Event description: Choose campaign
 *
 * @param {chooseCampaignParams} params - The parameters for this event
 * @property {GUID} campaignId - campaignId
 * @return {LogObject<chooseCampaignParams>} LogObject<chooseCampaignParams>
 */
export function chooseCampaign(params) {
    return { evid: 109, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'showHideDonationsWidgetElements' event (evid: 110)
 *
 * Event description: Show / Hide donations widget elements
 *
 * @param {showHideDonationsWidgetElementsParams} params - The parameters for this event
 * @property {boolean} show - show/hide
 * @property {string} element - title, description, frequency title, amount title, donor note title
 * @property {GUID} campaignId - campaignId
 * @property {string} componentId - Component identifier
 * @return {LogObject<showHideDonationsWidgetElementsParams>} LogObject<showHideDonationsWidgetElementsParams>
 */
export function showHideDonationsWidgetElements(params) {
    return { evid: 110, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'editDonationsFrequencySettings' event (evid: 111)
 *
 * Event description: Edit donations Frequency Settings
 *
 * @param {editDonationsFrequencySettingsParams} params - The parameters for this event
 * @property {string} element - show title, title text,default frequency.
 * @property {GUID} campaignId - campaignId
 * @property {string} value - show / hide (when element is show title), title, default frequency.
 * @return {LogObject<editDonationsFrequencySettingsParams>} LogObject<editDonationsFrequencySettingsParams>
 */
export function editDonationsFrequencySettings(params) {
    return { evid: 111, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickArchiveCampaign' event (evid: 112)
 *
 * Event description: Click Archive Campaign
 *
 * @param {clickArchiveCampaignParams} params - The parameters for this event
 * @property {string} origin - campaign panel, campaign form
 * @property {GUID} campaignId - campaignId
 * @return {LogObject<clickArchiveCampaignParams>} LogObject<clickArchiveCampaignParams>
 */
export function clickArchiveCampaign(params) {
    return { evid: 112, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickUnarchiveCampaign' event (evid: 113)
 *
 * Event description: Click Unarchive Campaign
 *
 * @param {clickUnarchiveCampaignParams} params - The parameters for this event
 * @property {string} origin - campaign panel, campaign form
 * @property {GUID} campaignId - campaignId
 * @return {LogObject<clickUnarchiveCampaignParams>} LogObject<clickUnarchiveCampaignParams>
 */
export function clickUnarchiveCampaign(params) {
    return { evid: 113, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickArchivedCampaignTab' event (evid: 114)
 *
 * Event description: Click Archived Campaign Tab
 *
 * @param {clickArchivedCampaignTabParams} params - The parameters for this event
 * @property {string} tab - active campaigns, archived campaigns
 * @return {LogObject<clickArchivedCampaignTabParams>} LogObject<clickArchivedCampaignTabParams>
 */
export function clickArchivedCampaignTab(params) {
    return { evid: 114, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickArchiveCampaignModal' event (evid: 115)
 *
 * Event description: Click Archive Campaign Modal
 *
 * @param {clickArchiveCampaignModalParams} params - The parameters for this event
 * @property {GUID} campaignId - campaignId
 * @return {LogObject<clickArchiveCampaignModalParams>} LogObject<clickArchiveCampaignModalParams>
 */
export function clickArchiveCampaignModal(params) {
    return { evid: 115, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'editDonorCommentSettings' event (evid: 117)
 *
 * Event description: Edit Donor Comment Settings
 *
 * @param {editDonorCommentSettingsParams} params - The parameters for this event
 * @property {string} element - show title, title text, show initial text, placeholder text, maximum characters.
 * @property {GUID} campaignId - campaignId
 * @property {string} value - show / hide (when element is show title), title, none/placeholder, placeholder text, maximum characters.
 * @property {GUID} siteOwnerId - uuid
 * @return {LogObject<editDonorCommentSettingsParams>} LogObject<editDonorCommentSettingsParams>
 */
export function editDonorCommentSettings(params) {
    return { evid: 117, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'viewDonationsWidgetInSf' event (evid: 125)
 *
 * Event description: view donations widget in SF
 *
 *  this event is currently indicates when a user choose campaign in the Editor
 *
 * @param {viewDonationsWidgetInSfParams} params - The parameters for this event
 * @property {boolean} hasDonorsSuggestedAmount - True / False
 * @property {boolean} hasDescription - True / False
 * @property {string} pageId - pageId
 * @property {boolean} hasTitle - True / False
 * @property {boolean} hasAmountByDonor - True / False
 * @property {boolean} hasNotesFromDonor - True / False
 * @property {GUID} campaignId - campaignId
 * @property {string} availableFrequency - list of available frequencies
 * @return {LogObject<viewDonationsWidgetInSfParams>} LogObject<viewDonationsWidgetInSfParams>
 */
export function viewDonationsWidgetInSf(params) {
    return { evid: 125, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'donationFrequencyChangeInSf' event (evid: 126)
 *
 * Event description: donation frequency change in SF
 *
 * @param {donationFrequencyChangeInSfParams} params - The parameters for this event
 * @return {LogObject<donationFrequencyChangeInSfParams>} LogObject<donationFrequencyChangeInSfParams>
 */
export function donationFrequencyChangeInSf(params) {
    return { evid: 126, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'donationAmountChangeInSf' event (evid: 127)
 *
 * Event description: donation amount change in SF
 *
 * @param {donationAmountChangeInSfParams} params - The parameters for this event
 * @return {LogObject<donationAmountChangeInSfParams>} LogObject<donationAmountChangeInSfParams>
 */
export function donationAmountChangeInSf(params) {
    return { evid: 127, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'clickOtherAmountSf' event (evid: 128)
 *
 * Event description: click Other Amount SF
 *
 * @param {clickOtherAmountSfParams} params - The parameters for this event
 * @return {LogObject<clickOtherAmountSfParams>} LogObject<clickOtherAmountSfParams>
 */
export function clickOtherAmountSf(params) {
    return { evid: 128, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'applyOtherAmountSf' event (evid: 129)
 *
 * Event description: apply Other Amount SF
 *
 * @param {applyOtherAmountSfParams} params - The parameters for this event
 * @return {LogObject<applyOtherAmountSfParams>} LogObject<applyOtherAmountSfParams>
 */
export function applyOtherAmountSf(params) {
    return { evid: 129, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'placeDonationSf' event (evid: 130)
 *
 * Event description: place donation SF
 *
 * @param {placeDonationSfParams} params - The parameters for this event
 * @property {number} amount - chosen amount
 * @property {string} frequency - chosen frequency
 * @property {boolean} keepAnonymous - True / False
 * @return {LogObject<placeDonationSfParams>} LogObject<placeDonationSfParams>
 */
export function placeDonationSf(params) {
    return { evid: 130, src: 168, endpoint: 'wixdonations', params: params };
}
/**
 * A function to create a log object for the 'donationThankYouPageLoadSf' event (evid: 131)
 *
 * Event description: Donation Thank You Page Load SF
 *
 * @param {donationThankYouPageLoadSfParams} params - The parameters for this event
 * @property {string} paymentStatus - Payment Status
 * @property {string} orderId - orderId
 * @property {string} catalogAppId - catalogAppId
 * @property {string} paymentMethodType - P ayment Method
 * @property {string} campaignId - campaign ID
 * @property {string} checkoutId - checkoutId
 * @return {LogObject<donationThankYouPageLoadSfParams>} LogObject<donationThankYouPageLoadSfParams>
 */
export function donationThankYouPageLoadSf(params) {
    return { evid: 131, src: 168, endpoint: 'wixdonations', params: params };
}
//# sourceMappingURL=index.js.map